import React, { useEffect } from 'react'
import { IProject, ITmpProject } from '../../starter/model/interfaces'
import style from './cardProjectSmall.module.scss'
import { Tooltip } from 'antd'
import PersonContactSet from '../PersonContactSet/PersonContactSet'
import { EditOutlined } from '@ant-design/icons'
import { useDeleteProjectMutation, useUpdateProjectMutation } from '../../starter/api/projectsApi'
import { store } from '../../starter/redux/store'
import CreateProject from '../CreateProject/CreateProject'
import { useActions } from '../../starter/hooks/actions'

import { useDrag } from 'react-dnd'
import CardProjectTooltip from '../CardProject/CardProjectTooltip'
import { useAppSelector } from '../../starter/hooks/redux'
type TCardProject = {
  project: IProject
}
export default function CardProjectSmall({ project }: TCardProject) {
  const [
    updateProject,
    { isLoading: isLoadingUpdate, isSuccess: isSuccessUpdateProject, isError: isErrorUpdate, error: errorUpdate }
  ] = useUpdateProjectMutation()
  const [
    deleteProject,
    { isLoading: isLoadingDelete, isSuccess: isSuccessDeleteProject, isError: isErrorDelete, error: errorDelete }
  ] = useDeleteProjectMutation()
  const { setButtonSet, setError, onShowModal, setModalData, setTmpProject } = useActions()
  const { buttonSet } = useAppSelector((state) => state.modal)
  useEffect(() => {
    if (isErrorUpdate || isErrorDelete) {
      setError({
        isError: true,
        // @ts-ignore
        message: (errorUpdate && errorUpdate.data) || (errorDelete && errorDelete.data)
      })
    }
  }, [isErrorUpdate, isErrorDelete, errorUpdate, errorDelete])

  useEffect(() => {
    onShowModal(false)
  }, [isSuccessUpdateProject, isSuccessDeleteProject])

  useEffect(() => {
    setButtonSet(
      buttonSet.map((button) => ({
        ...button,
        loading: (isLoadingUpdate || isLoadingDelete) && button.type === 'primary'
      }))
    )
  }, [isLoadingUpdate, isLoadingDelete])

  const [, projectRef] = useDrag({
    type: 'project-small',
    item: project,
    collect: (monitor) => monitor
  })

  const editProject = () => {
    onShowModal(true)
    const tmpProject = { ...(project as ITmpProject) }
    tmpProject.validate = {
      isValid: false,
      showError: false,
      message: []
    }
    setTmpProject(tmpProject)
    setButtonSet([
      {
        type: 'primary',
        loading: isLoadingDelete,
        danger: true,
        confirm: {
          text: 'Удалить проект',
          description: `Вы уверены, что хотите удалить проект: ${project.title}`,
          onConfirm: () => {
            const { project } = { ...store.getState().tmp }
            if (project) {
              deleteProject(project._id)
            }
          }
        },
        children: 'Удалить'
      },
      {
        type: 'primary',
        loading: isLoadingUpdate,
        onClick: () => {
          const { project } = { ...store.getState().tmp }
          if (project && project.validate?.isValid) {
            updateProject(project)
          } else {
            // todo что-то странное ниже
            const _project: ITmpProject = JSON.parse(JSON.stringify(project)) //{...employee}
            _project.validate.showError = true
            setTmpProject(_project)
          }
        },
        children: 'Ok'
      },
      {
        onClick: () => onShowModal(false),
        children: 'Cancel'
      }
    ])
    setModalData({
      title: 'Введите данные проекта',
      content: <CreateProject />
    })
  }

  return (
    <div ref={projectRef}>
      <div className={style.wrapper}>
        <div className={style.title}>
          <Tooltip
            overlayInnerStyle={{ width: '35rem' }}
            title={() => <CardProjectTooltip project={project} />}
            trigger={'click'}>
            <div>{project.title}</div>
          </Tooltip>
          <EditOutlined
            style={{ cursor: 'pointer' }}
            onClick={() => {
              editProject()
            }}
          />
        </div>
        <div className={style.code}>{project.code}</div>
        <div className={style.responsible}>
          <div className={style.card}>{project.manager && <PersonContactSet person={project.manager} />}</div>
          <div className={style.card}>
            {project.responsibleEmployee && <PersonContactSet person={project.responsibleEmployee} />}
          </div>
        </div>
        <div className={style.progressBar}></div>
      </div>
    </div>
  )
}
